const baseUrl = "https://rubimoni.com:8443/";

export { baseUrl }